import { ExpandMore } from "@mui/icons-material"
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material"
import { ReactNode } from "react";

interface KaziAccordionProps {
    summary: string;
    content: ReactNode;
}
export const KaziAccordion = ({summary, content}: KaziAccordionProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Accordion
            sx={{
                border: 'none',
                boxShadow: 'none'
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                    padding: 0
                }}
            >
                
                <Typography variant="body-medium">{summary}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {content}
            </AccordionDetails>
        </Accordion>
    )
}